import React from 'react';
import classNames from 'classnames';

import { Link } from '@lt/components';
import { useTranslation } from '@lt/localization';

import styles from './operatorDetails.module.css';

interface Props {
  className?: string;
  operatorName?: string;
  bookingUrl: string | null;
  isLoggedUser?: boolean;
}

export const OperatorDetails = ({
  className = '',
  operatorName,
  bookingUrl,
  isLoggedUser,
}: Props) => {
  const { t } = useTranslation();
  if (!operatorName) return null;

  return isLoggedUser && bookingUrl ? (
    <Link className={classNames(className, styles.link)} href={bookingUrl}>
      {t('checkout.packageInfo.operatorDetails')} {operatorName}
    </Link>
  ) : (
    <span className={classNames(className, styles.link)}>
      {t('checkout.packageInfo.operatorDetails')} {operatorName}
    </span>
  );
};
